export default theme => ({
    root: {
        width: "auto",
        [theme.breakpoints.up("md")]: {
            width: "100%",
        }
    }
});